module.exports = __webpack_public_path__ + "static/media/Icon.52b4a1ba.svg";